export default class UploadFile {
    constructor() {
        this.fileField = document.querySelector(".file-upload");
        this.otaField = document.getElementById("upload_tour_group_otaAgentCode");

        if (this.fileField != null && this.otaField != null) {
            this.labelFileField = this.fileField.querySelector(".file-upload-field_label").getAttribute("data-tpl");
            this.otaField.addEventListener("changeOnSelect", () => {
                if (this.otaField.value) {
                    this.fileField.style.display = "block";
                } else {
                    this.fileField.style.display = "none";
                }
            });
            this.otaField.dispatchEvent(new Event("changeOnSelect"));
        }

        this.autoSubmitFields = document.querySelectorAll(".js-autosubmit");
        this.autoSubmitFields.forEach((autoSubmitField) => {
            autoSubmitField.addEventListener("change", () => {
                autoSubmitField.closest("form").submit();
            });
        });

        this.inputsFile = document.querySelectorAll("input[type=file]");
        this.inputsFile.forEach((inputFile) => {
            this.inputFileLabel = inputFile.closest(".file-upload-field").querySelector(".file-upload-field_label");
            if (this.inputFileLabel) {
                this.inputFileTpl = this.inputFileLabel.getAttribute("data-tpl").replace(/\[/g, "<").replace(/\]/g, ">").replace(/'/g, "\"");
                this.inputFileHtml = document.createElement("div");
                this.inputFileHtml.innerHTML = this.inputFileTpl;
                this.inputFileLabel.prepend(this.inputFileHtml.firstChild);
            }
        });
    }
}
